<script lang="ts">
  import Check from "svelte-radix/Check.svelte";
  import CaretSort from "svelte-radix/CaretSort.svelte";
  import { createEventDispatcher, tick } from "svelte";
  import * as Command from "$lib/components/ui/command/index.js";
  import * as Popover from "$lib/components/ui/popover/index.js";
  import { Button } from "$lib/components/ui/button/index.js";
  import { cn } from "$lib/utils.js";
  import { get } from "svelte/store";
  import  type { InstallationType } from "$src/domain/projects/installations/InstallationType";

  import { t } from "svelte-i18n";
  import { useInstallationType } from "../hooks/useInstallationType";
  let open = false;

  export let groupStoreId: number;
  export let value: InstallationType | undefined;

  $: installationTypesQuery = useInstallationType(groupStoreId);

  const dispatch = createEventDispatcher();

  function handleSelect(currentValue: string, ids: any) {
    const selectedValue = get(installationTypesQuery).data?.find(
      (f) => f.id.toString() === currentValue
    );
    if (selectedValue) {
      value = selectedValue.id;
      dispatch("change", { value: selectedValue });
    }

    closeAndFocusTrigger(ids.trigger);
  }

  // We want to refocus the trigger button when the user selects
  // an item from the list so users can continue navigating the
  // rest of the form with the keyboard.
  function closeAndFocusTrigger(triggerId: string) {
    open = false;
    tick().then(() => {
      document.getElementById(triggerId)?.focus();
    });
  }
</script>

<Popover.Root bind:open let:ids>
  <Popover.Trigger asChild let:builder>
    <Button
      builders={[builder]}
      variant="outline"
      role="combobox"
      aria-expanded={open}
      class="w-[260px] justify-between font-normal"
    >
      <!-- {#if value} -->
        {$t('page.projects.detail.installation.types.' + value)}
      <!-- {:else}
        {$t('page.projects.detail.installation.empty')};
      {/if} -->
      <CaretSort class="ml-2 h-4 w-4 shrink-0 opacity-50" />
    </Button>
  </Popover.Trigger>
  <Popover.Content class="w-[260px] p-0">
    <Command.Root>
      <Command.Group>
        {#if $installationTypesQuery.isSuccess}
          {#each $installationTypesQuery.data as installationType}
            <Command.Item
              value={installationType.id.toString()}
              onSelect={(currentValue) => handleSelect(currentValue, ids)}
            >
              <Check
                class={cn(
                  "mr-2 h-4 w-4",
                  value?.toString() !== installationType.id.toString() &&
                    "text-transparent"
                )}
              />
              {$t(`page.projects.detail.installation.types.${installationType.id}`)}
            </Command.Item>
          {/each}
        {/if}
      </Command.Group>
    </Command.Root>
  </Popover.Content>
</Popover.Root>
